// Avviso alla conclusione di un mandato con incarichi ancora aperti. È solo un avviso:
// il mandato si conclude comunque e gli incarichi restano come sono.
// I conteggi arrivano da GET /praticas/{id}/riepilogo-chiusura.

export interface IncarichiApertiConteggio {
    incarichiDaAccettare?: number;
    incarichiAccettati?: number;
    incarichiInCorso?: number;
    incarichiAperti?: number;
}

export const totaleIncarichiAperti = (c?: IncarichiApertiConteggio | null): number => {
    if (!c) return 0;
    const somma = (c.incarichiDaAccettare || 0) + (c.incarichiAccettati || 0) + (c.incarichiInCorso || 0);
    return Math.max(c.incarichiAperti || 0, somma);
};

// "Ci sono 3 incarichi ancora aperti (1 da accettare, 2 in corso)."
export const fraseIncarichiAperti = (c: IncarichiApertiConteggio): string => {
    const n = totaleIncarichiAperti(c);
    const dettagli: string[] = [];
    if (c.incarichiDaAccettare) dettagli.push(`${c.incarichiDaAccettare} da accettare`);
    if (c.incarichiAccettati) dettagli.push(`${c.incarichiAccettati} ${c.incarichiAccettati === 1 ? 'accettato non avviato' : 'accettati non avviati'}`);
    if (c.incarichiInCorso) dettagli.push(`${c.incarichiInCorso} in corso`);
    const testa = n === 1 ? "C'è 1 incarico ancora aperto" : `Ci sono ${n} incarichi ancora aperti`;
    return `${testa}${dettagli.length ? ` (${dettagli.join(', ')})` : ''}.`;
};

export const ISTRUZIONI_INCARICHI_APERTI =
    'Revocali o chiedi al collaboratore di chiudere il servizio. '
    + 'Il mandato verrà comunque segnato come Concluso, gli incarichi restano invariati.';

export const testoAvvisoIncarichiAperti = (c: IncarichiApertiConteggio): string =>
    `${fraseIncarichiAperti(c)} ${ISTRUZIONI_INCARICHI_APERTI}`;
